<script>
    import { onMount } from "svelte";
    import { changeBgColor } from "../scripts/utils";
    import { questions, lang } from "../scripts/stores";
    import LoadModal from "../components/LoadModal.svelte";
    import { data_home_en, data_home_fi } from "../data/content";

    let pageContent = $lang === "en" ? data_home_en : data_home_fi;
    $: if($lang) pageContent = $lang === "en" ? data_home_en : data_home_fi;
    
    let open = false;
    let fileName = "";

    function upload() {
        document.getElementById("upload").click();
    }

    function loadFromDevice(e) {
        const file = e.target.files[0] ? e.target.files[0] : null;

        if(!file) return;

        const fr = new FileReader();

        fr.onload = function(e) { 
            console.log(e);
            const result = JSON.parse(e.target.result);
            $questions = result;

            fileName = file.name;
            open = true;
        }

        fr.readAsText(file);
    }

    onMount(() => {
        changeBgColor("#fffff");
        window.scrollTo(0, 0);
	});

</script>

<div class="container">
    <div class="main-text-container">        
        <div class="logos">
            <img class="logo" src="eu-logo.png" alt="Vipuvoimaa EU:lta logo" />
            <img class="logo" src="eu-logo2.png" alt="Eu-logo" />
        </div>
        {@html pageContent}

        <div class="button">
            <input type="file" hidden id="upload" on:change={ loadFromDevice } />

            <button class="btn btn-primary btn-outline" on:click={ upload }>
                <i class="material-icons btn-icon">upload</i>
                { $lang == "fi" ? "Lataa" : "Upload" }
            </button>
        
            <a class="btn btn-primary" type="button" href="/#/form/1/1">
                <i class="material-icons btn-icon">poll</i>
                { $lang == "fi" ? "Aloita kartoitus" : "Start survey" }
            </a>
        </div>

        <div class="button" style="margin-top: 1.5rem;">
            <a class="btn btn-success" type="button" href="https://elomake.samk.fi/lomakkeet/12540/lomake.html" target="_blank">
                <i class="material-icons" style="margin-right: 0.5rem;">feedback</i>
                { $lang == "fi" ? "Anna palautetta" : "Feedback" }
            </a>
        </div>
    </div>
</div>

<LoadModal bind:open />

<style>
    .logos {
        display: flex;
        justify-content: flex-end;
        align-items: flex-start;
        gap: 36px;
        margin-top: 1rem;
    }

    .logo {
        width: 100px;
    }

    @media screen and (max-width: 420px) {
        .logos {
            justify-content: space-between;
        }
    }
</style>